import request from "../utils/request";

export const getCountryMappings = '/country/mapping/'

export function modifyCountryMapping(data: any) {
    return request.request({
        url: '/country/mapping/',
        method: data.id ? 'put' : 'post',
        data: data
    })
}

export function deleteCountryMapping(id: number) {
    return request.request({
        url: '/country/mapping/',
        method: 'delete',
        params: {mappingId: id}
    })
}
